import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axios-instance";

export const fetchApplication = createAsyncThunk(
    "application/fetchApplication",
    async () => {
        try {
            const response = await axiosInstance({
                method: "get",
                url: "/application"
            });
            return response.data.data;
        } catch (error) {
            if(error?.response?.data?.data?.status === "4") {
                return []
            }
            return Promise.reject(error);
        }
    }
);
